<svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 15L0.999999 8L8 1" stroke="#8148a8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
